import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	multipleVersionsContent: {
		id: 'card.common.custom-fields.card-custom-field.text-fix-versions-custom-field-content.multiple-versions-content',
		defaultMessage: '{versionsCount} versions',
		description: 'versions count message for fix versions custom field',
	},
});
